.screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 26px;
  animation: evx-fadeUp 0.5s ease both;
}
.leaving {
  animation: evx-fadeOut 0.5s ease 0.65s both;
}
.intro {
  text-align: center;
}
.heading {
  margin: 10px 0 8px;
  font-size: 38px;
  font-weight: 800;
  color: var(--color-text);
}
.subheading {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-neutral-700);
}

/*
 * The column is as tall as the stage, so nothing in it may change height between states: the PIN
 * box is fixed at the height the approved design renders at, and the feedback line overlays the
 * gap beneath it instead of taking a row of its own.
 */
.pinArea {
  position: relative;
  flex: none;
}
.pinBox {
  position: relative;
  width: 400px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}
.shake {
  animation: evx-shake 0.45s ease;
}
.pinDot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--color-neutral-300);
  background: transparent;
  transition: background 0.15s;
}
.filled {
  border-color: var(--color-accent);
  background: var(--color-accent);
}
.granted .filled {
  border-color: var(--color-success);
  background: var(--color-success);
}
.denied .filled {
  border-color: var(--color-danger);
  background: var(--color-danger);
}
.grantedRing {
  position: absolute;
  inset: -3px;
  border-radius: calc(var(--radius-lg) + 3px);
  border: 2px solid var(--color-success);
  animation: evx-okPulse 1s ease-out infinite;
}

.feedback {
  position: absolute;
  top: calc(100% + 2px);
  left: -100px;
  right: -100px;
  text-align: center;
  white-space: nowrap;
  font-family: var(--font-heading);
  font-size: 15px;
  font-weight: 700;
}
.feedbackGranted {
  color: var(--color-success);
  animation: evx-reveal 0.4s ease both;
}
.feedbackDenied {
  color: var(--color-danger);
  animation: evx-blink 0.35s infinite;
}
.feedbackUnavailable {
  color: var(--color-danger);
}

.keypad {
  display: grid;
  grid-template-columns: repeat(3, 128px);
  gap: 16px;
}
.key {
  height: 92px;
  background: var(--color-surface);
  border: none;
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 32px;
  color: var(--color-text);
  cursor: pointer;
  box-shadow: var(--shadow-sm);
}
.key:hover {
  background: var(--color-accent-100);
  color: var(--color-accent-700);
  box-shadow: var(--shadow-md);
}
.key:active {
  background: var(--color-accent-200);
}
.keyCommand {
  font-weight: 800;
  font-size: 18px;
}
.hint {
  font-size: 12px;
  color: var(--color-neutral-500);
  font-weight: 600;
}
